// extracted by mini-css-extract-plugin
module.exports = {"logo":"Page404_logo__3R5w2"};